<template>
  <main class="main main__profile" role="main">
    <section class="mainHeader">
      <div class="page">
        <div class="card">
          <h2>Uppps <strong>🥲</strong></h2>
          <p>Te pedimos disculpas, no pudimos encontrar la página que estás buscando.</p>
            <h1>error: {{error.statusCode}}</h1>
          <a href="#" class="bt" @click.prevent="handleError">{{$t('errors.backToHome')}}</a></div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import type {NuxtError} from '#app'

definePageMeta({layout: 'base-layout',});

defineProps({
  error: Object as () => NuxtError
})

const handleError = () => clearError({redirect: '/'})
</script>